import './styles.scoped.css'
import {useState, useRef, useEffect} from 'react'
import {ProfilePopUp, NotificationIcon} from '../../components'
import {Typography, Avatar, Skeleton, Menu, MenuItem, ListItemIcon} from '@mui/material'
import {PlayArrow, Logout, Person} from '@mui/icons-material'
import {useAuth} from '../../contexts/AuthContext'
import {getInitials, getColorFromName, parseError} from '../../utils/helpers'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {caregiverApi} from '../../services'
import {Link} from 'react-router-dom'

export default () => {
    const [initials, setInitials] = useState(null)
    const [avatarColor, setAvatarColor] = useState(null)
    const {user} = useAuth()
    const [anchorElProfile, setAnchorElProfile] = useState(null)
    const {setLogout} = useGlobalStates()

    useEffect(() => {
        if (!user?.avatar_url) {
            setInitials(getInitials(user?.first_name + ' ' + user?.last_name))
            setAvatarColor(getColorFromName(user?.first_name + ' ' + user?.last_name))
        }
    }, [user])

    const menuOpenProfile = e => {
        setAnchorElProfile(e.currentTarget)
    }

    const menuCloseProfile = () => {
        setAnchorElProfile(null)
    }

    const logout = () => {
        menuCloseProfile()
        setLogout(true)
    }

    return (
        <div className="container">
            <div className="header">
                <NotificationIcon />
                <div className="profile" onClick={e => menuOpenProfile(e)}>
                    {user?.email ? (
                        <>
                            {user?.avatar_url && <Avatar src={user?.avatar_url} style={{width: 40, height: 40}} />}
                            {!user?.avatar_url && (
                                <Avatar style={{width: 40, height: 40, fontSize: 20, backgroundColor: avatarColor}}>{initials}</Avatar>
                            )}
                        </>
                    ) : (
                        <Skeleton variant="circular" height={40} width={40} />
                    )}
                    <div className="name-container">
                        {user?.email ? (
                            <>
                                <Typography variant="h8" color="text.primary">
                                    {user?.first_name + ' ' + user?.last_name}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {user?.email}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Skeleton variant="text" width={130} sx={{fontSize: 16}} />
                                <Skeleton variant="text" width={170} sx={{fontSize: 12}} />
                            </>
                        )}
                    </div>
                    {user?.email && (
                        <PlayArrow
                            fontSize="small"
                            style={{transform: 'rotate(90deg)'}}
                            sx={theme => ({
                                color: theme.palette.grey[800],
                            })}
                        />
                    )}
                </div>
            </div>
            <Menu
                anchorEl={anchorElProfile}
                open={Boolean(anchorElProfile)}
                onClose={menuCloseProfile}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                MenuListProps={{
                    autoFocusItem: false,
                }}
                PaperProps={{
                    sx: {
                        marginTop: 2,
                    },
                }}>
                <MenuItem component={Link} to="/account-settings" onClick={menuCloseProfile}>
                    <ListItemIcon>
                        <Person fontSize="small" />
                    </ListItemIcon>
                    <Typography variant="menuItem">Profile</Typography>
                </MenuItem>
                <MenuItem onClick={logout}>
                    <ListItemIcon>
                        <Logout fontSize="small" color="error" />
                    </ListItemIcon>
                    <Typography variant="menuItem" color="error">
                        Sign Out
                    </Typography>
                </MenuItem>
            </Menu>
        </div>
    )
}
